import { useLocation } from "react-router-dom";
import { useEffect, useState, useRef, forwardRef } from "react";

const PageTransition = forwardRef(function PageTransition({ children }, ref) {
  const location = useLocation();
  const [displayChildren, setDisplayChildren] = useState(children);
  const [transitionState, setTransitionState] = useState("entered");
  const prevPath = useRef(location.pathname);

  useEffect(() => {
    if (location.pathname !== prevPath.current) {
      setTransitionState("exiting");
      const timer = setTimeout(() => {
        setDisplayChildren(children);
        prevPath.current = location.pathname;
        window.scrollTo({ top: 0, behavior: "instant" });
        setTransitionState("entering");
        const enterTimer = setTimeout(() => setTransitionState("entered"), 300);
        return () => clearTimeout(enterTimer);
      }, 200);
      return () => clearTimeout(timer);
    } else {
      setDisplayChildren(children);
    }
  }, [location.pathname, children]);

  return (
    <div
      ref={ref}
      className="page-transition"
      style={{
        opacity: transitionState === "exiting" ? 0 : 1,
        transform: transitionState === "exiting" ? "translateY(8px)" : "translateY(0)",
        transition: "opacity 0.3s cubic-bezier(0.4, 0, 0.2, 1), transform 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
      }}
    >
      {displayChildren}
    </div>
  );
});

export default PageTransition;
